// Spinner.jsx
import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 40, color = '#3EB454' }) => (
  <div
    className="spinner"
    style={{
      width: size,
      height: size,
      border: `${size / 8}px solid ${color}33`,    // %20 transparan kenarlar
      borderTop: `${size / 8}px solid ${color}`,   // dönen kısmın rengi
      borderRadius: '50%',
    }}
  />
);

export default Spinner;
